import React, { Fragment } from 'react';
import Image from '../../assets/Services/question.svg'
import './Question.css';
import Fade from 'react-reveal/Fade';
import { Dimensions } from "../../Helper/sitedimension";

const question = () => {
    const { width } = Dimensions.useWindowDimensions();

    return (
        <div className="question">
            {width > 500 ?
                <Fragment>
                    <div className="container-fluid bg-1">
                        <div className="main">
                            <Fade delay={250}>
                                <span className="content"> What is  </span>
                            </Fade>
                        </div>
                        <div className="main1">
                            <Fade delay={500}>
                                <span className="content"> VA & PT? </span>
                            </Fade>
                        </div>
                        <div className="content1">
                            <Fade delay={750}>
                            Finding the critical vulnerabilities out of hundreds of applications running inside your 
                            organisation, is just a small part of your job. Our vulnerability management planning 
                            is such that we try to go the extra mile and take it upon us help you 
                            manage the findings and get them patched or at least addressed within a defined timeline.
                            </Fade>
                        </div>
                    </div>
                    <Fade delay={1200}>
                        <img className="question-image" src={Image} alt="question" />
                    </Fade>
                </Fragment> :
                <Fragment>
                    <div className="container-fluid bg-1">
                        <div className="mainques">
                            <Fade delay={250}>
                                <span className="content"> What is  </span>
                            </Fade>
                        </div>
                        <div className="main1ques">
                            <Fade delay={500}>
                                <span className="content"> VA & PT? </span>
                            </Fade>
                        </div>
                        <div className="content1ques">
                            <Fade delay={750}>
                            Finding the critical vulnerabilities out of hundreds of applications running inside your 
                            organisation, is just a small part of your job. Our vulnerability management planning 
                            is such that we try to go the extra mile and take it upon us help you 
                            manage the findings and get them patched or at least addressed within a defined timeline.
                            </Fade>
                        </div>
                    </div>
                </Fragment>}
        </div>
    )
}

export default question;